/* CUSTOM workshop-booking.js (Shopify-Session)
 *
 * Guided multi-seat workshop booking + voucher gift flow.
 */
(function () {
  if (customElements.get('workshop-booking')) return;

  const WD_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const WD_LABELS_SHORT_SUN0 = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MONTHS_LONG = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const LANG = document.documentElement.lang || 'en';
  function readI18n(el) { try { return JSON.parse(el.querySelector('script[data-i18n]')?.textContent || '{}'); } catch (e) { return {}; } }
  function tpl(s, vars) { return String(s).replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (vars[k] ?? '')); }
  const wdShort = (i) => new Intl.DateTimeFormat(LANG, { weekday: 'short' }).format(new Date(2024, 0, 1 + i));
  const monthLong = (y, m) => new Intl.DateTimeFormat(LANG, { month: 'long' }).format(new Date(y, m, 1));

  function dateKey(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  /** Sessions aus Variant-Metafeld (custom.sessions). Liefert Array { date: Date, from, to, label }. */
  function readSessions(v) {
    const raw = v.sessions || [];
    return raw.map(s => ({
      date: new Date(`${s.date}T00:00:00`),
      from: s.from || '',
      to: s.to || '',
      label: s.label || '',
    })).sort((a, b) => a.date - b.date);
  }

  function isoWeek(d) {
    const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const day = date.getUTCDay() || 7;
    date.setUTCDate(date.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    return Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
  }

  function mondayOf(d) {
    const day = (d.getDay() + 6) % 7;
    const monday = new Date(d.getFullYear(), d.getMonth(), d.getDate() - day);
    monday.setHours(0, 0, 0, 0);
    return monday;
  }

  function daysUntil(d, today) { return Math.ceil((d - today) / 86400000); }

  class WorkshopBooking extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.I = readI18n(this);
      const wjson = this.querySelector('[data-workshop-variants]');
      const ejson = this.querySelector('[data-evening-variants]');
      this.variantsByModel = {
        workshop: wjson ? JSON.parse(wjson.textContent) : [],
        evening: ejson ? JSON.parse(ejson.textContent) : [],
      };
      this.voucherIds = {
        workshop: { digital: this.dataset.voucherWorkshopDigital, post: this.dataset.voucherWorkshopPost },
        evening: { digital: this.dataset.voucherEveningDigital, post: this.dataset.voucherEveningPost },
      };

      this.steps = {
        calendar: this.querySelector('[data-step="calendar"]'),
        voucherModel: this.querySelector('[data-step="voucher-model"]'),
        voucher: this.querySelector('[data-step="voucher"]'),
        qty: this.querySelector('[data-step="qty"]'),
        seats: this.querySelector('[data-step="seats"]'),
        buy: this.querySelector('[data-step="buy"]'),
      };
      this.calendarEl = this.querySelector('[data-calendar]');
      this.summaryEl = this.querySelector('[data-summary]');
      this.seatsEl = this.querySelector('[data-seats]');
      this.seatsHeadingEl = this.querySelector('[data-seats-heading]');
      this.qtyBtnsEl = this.querySelector('[data-qty-buttons]');
      this.qtyMetaEl = this.querySelector('[data-qty-meta]');
      this.notifyWrap = this.querySelector('[data-notify-wrap]');
      this.notifyTitle = this.querySelector('[data-notify-title]');
      this.notifyToggle = this.querySelector('#wb-notify');
      this.infoBox = this.querySelector('[data-info-box]');
      this.infoTextEl = this.querySelector('[data-info-text]');
      this.giftExtra = this.querySelector('[data-gift-extra]');
      this.buyBtn = this.querySelector('button[type="submit"]');
      this.buyId = this.querySelector('[data-buy-id]');
      this.buyLabel = this.querySelector('[data-buy-label]');

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      this.today = today;
      this.todayKey = dateKey(today);

      this.buildDayMap();

      this.state = {
        model: null,
        variantId: null,
        maxQty: 1,
        qty: 1,
        seats: [{ type: 'self', name: '', email: '' }],
        notSure: false,
        voucherFormat: 'digital',
        filter: 'all',
      };

      this.querySelectorAll('input[name="voucher_model"]').forEach(r =>
        r.addEventListener('change', (e) => this.selectVoucherModel(e.target.value))
      );
      this.querySelectorAll('input[name="voucher_format"]').forEach(r =>
        r.addEventListener('change', (e) => { this.state.voucherFormat = e.target.value; this.renderSummary(); this.refreshBuy(); })
      );
      if (this.qtyBtnsEl) {
        this.qtyBtnsEl.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-qty]');
          if (btn && !btn.disabled) this.setQty(parseInt(btn.dataset.qty, 10));
        });
      }
      if (this.notifyToggle) {
        this.notifyToggle.addEventListener('change', () => this.refreshBuy());
      }
      // Format-Kacheln: Filter NUR per Klick (Hover bleibt rein visuell via CSS)
      this.querySelectorAll('[data-format]').forEach(card => {
        card.addEventListener('click', () => {
          this.setFilter(card.dataset.format);
          this.querySelectorAll('[data-format]').forEach(c => c.classList.toggle('is-active', c === card));
        });
      });

      this.form.addEventListener('submit', (e) => this.submit(e));

      this.render();
      this.renderCalendar();
    }

    buildDayMap() {
      this.dayMap = new Map();
      this.variantInfo = new Map();
      ['workshop', 'evening'].forEach(model => {
        (this.variantsByModel[model] || []).forEach(v => {
          const sessions = readSessions(v);
          if (!sessions.length) return;
          if (sessions[0].date < this.today) return;
          const dates = sessions.map(s => s.date);
          this.variantInfo.set(v.id, {
            model,
            firstDate: dates[0],
            lastDate: dates[dates.length - 1],
            available: v.available,
            qty: v.qty,
            dates,
            sessions,
          });
          sessions.forEach(s => {
            this.dayMap.set(dateKey(s.date), { model, variantId: v.id, available: v.available, qty: v.qty, date: s.date });
          });
        });
      });
      this.lastSessionDate = null;
      this.variantInfo.forEach(v => {
        if (!this.lastSessionDate || v.lastDate > this.lastSessionDate) this.lastSessionDate = v.lastDate;
      });
    }

    cellVisibleForFilter(info) {
      if (this.state.filter === 'all') return true;
      return info && info.model === this.state.filter;
    }

    renderCalendar() {
      this.calendarEl.innerHTML = '';
      const wrap = document.createElement('div');
      wrap.className = 'workshop-booking__cal-wrap';

      const seg = document.createElement('div');
      seg.className = 'workshop-booking__seg';
      seg.setAttribute('role', 'tablist');
      [
        { value: 'all', label: 'All' },
        { value: 'workshop', label: '3-Session' },
        { value: 'evening', label: '1-Session' },
      ].forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'workshop-booking__seg-btn';
        btn.dataset.filter = opt.value;
        btn.textContent = opt.label;
        if (this.state.filter === opt.value) btn.classList.add('is-active');
        btn.addEventListener('click', () => this.setFilter(opt.value));
        seg.appendChild(btn);
      });
      wrap.appendChild(seg);

      const weeks = new Map();
      this.dayMap.forEach((info, k) => {
        if (!this.cellVisibleForFilter(info)) return;
        const wk = isoWeek(info.date);
        const monday = mondayOf(info.date);
        const weekKey = `${monday.getFullYear()}-${String(wk).padStart(2, '0')}`;
        if (!weeks.has(weekKey)) {
          weeks.set(weekKey, { monday, weekNum: wk, sessions: new Map() });
        }
        weeks.get(weekKey).sessions.set(k, info);
      });

      const weeksContainer = document.createElement('div');
      weeksContainer.className = 'workshop-booking__weeks';

      if (weeks.size === 0) {
        const empty = document.createElement('p');
        empty.className = 'workshop-booking__weeks-empty';
        empty.textContent = this.I.no_dates || 'No upcoming dates for this format.';
        weeksContainer.appendChild(empty);
      } else {
        const sortedWeeks = [...weeks.values()].sort((a, b) => a.monday - b.monday);
        const groups = new Map();
        sortedWeeks.forEach(week => {
          const first = [...week.sessions.values()].sort((a, b) => a.date - b.date)[0].date;
          const gKey = `${first.getFullYear()}-${first.getMonth()}`;
          if (!groups.has(gKey)) groups.set(gKey, { year: first.getFullYear(), month: first.getMonth(), weeks: [] });
          groups.get(gKey).weeks.push(week);
        });
        const groupEls = [];
        [...groups.values()].forEach(g => {
          const el = this.renderMonthGroup(g);
          weeksContainer.appendChild(el);
          groupEls.push(el);
        });
        const lastList = groupEls[groupEls.length - 1].querySelector('.workshop-booking__monthgroup-list');
        if (lastList) lastList.appendChild(this.renderAnnounceRow());
      }
      wrap.appendChild(weeksContainer);

      const notSure = document.createElement('button');
      notSure.type = 'button';
      notSure.className = 'workshop-booking__notsure-tile';
      notSure.dataset.notSure = 'true';
      notSure.innerHTML = `
        <span class="workshop-booking__notsure-name">Not sure about the date yet</span>
        <span class="workshop-booking__notsure-meta">Buy a voucher instead</span>
      `;
      if (this.state.notSure) notSure.classList.add('is-selected');
      notSure.addEventListener('click', () => this.gotoVoucher());
      wrap.appendChild(notSure);

      this.calendarEl.appendChild(wrap);
    }

    renderMonthGroup(group) {
      const wrap = document.createElement('div');
      wrap.className = 'workshop-booking__monthgroup';
      const header = document.createElement('h3');
      header.className = 'workshop-booking__monthgroup-header';
      header.textContent = `${monthLong(group.year, group.month)} ${group.year}`;
      wrap.appendChild(header);
      const list = document.createElement('div');
      list.className = 'workshop-booking__monthgroup-list';
      group.weeks.forEach(week => list.appendChild(this.renderWeek(week)));
      wrap.appendChild(list);
      return wrap;
    }

    renderWeek(week) {
      const wrap = document.createElement('div');
      wrap.className = 'workshop-booking__week';
      const row = document.createElement('div');
      row.className = 'workshop-booking__week-row';

      for (let i = 0; i < 7; i++) {
        const date = new Date(week.monday.getFullYear(), week.monday.getMonth(), week.monday.getDate() + i);
        const k = dateKey(date);
        const info = week.sessions.get(k);

        let cell;
        if (info) {
          cell = document.createElement(info.available ? 'button' : 'div');
          if (info.available) cell.type = 'button';
          cell.className = `workshop-booking__day is-session is-model-${info.model}` + (info.available ? '' : ' is-soldout');
          cell.dataset.variantId = info.variantId;
          cell.dataset.model = info.model;

          const seatsText = info.available
            ? (info.qty > 0 ? tpl(this.I.seats_left || '{{ n }} seats left', { n: info.qty }) : (this.I.last_seats || 'Last seats'))
            : (this.I.sold_out || 'Sold out');

          cell.innerHTML = `
            <span class="workshop-booking__day-wd">${wdShort(i)}</span>
            <span class="workshop-booking__day-num">${date.getDate()}</span>
            <span class="workshop-booking__day-seats">${seatsText}</span>
          `;

          if (info.available) {
            cell.addEventListener('click', () => this.selectDate(info.model, info.variantId));
            cell.addEventListener('mouseenter', () => this.hoverVariant(info.variantId, true));
            cell.addEventListener('mouseleave', () => this.hoverVariant(info.variantId, false));
          }
          if (this.state.variantId === info.variantId) cell.classList.add('is-selected');
        } else {
          cell = document.createElement('div');
          cell.className = 'workshop-booking__day is-empty';
          cell.innerHTML = `
            <span class="workshop-booking__day-wd">${wdShort(i)}</span>
            <span class="workshop-booking__day-num">${date.getDate()}</span>
          `;
        }
        if (k === this.todayKey) cell.classList.add('is-today');
        row.appendChild(cell);
      }

      wrap.appendChild(row);
      return wrap;
    }

    renderAnnounceRow() {
      const wrap = document.createElement('div');
      wrap.className = 'workshop-booking__week workshop-booking__announce';
      if (!this.lastSessionDate) return wrap;

      const announce = new Date(this.lastSessionDate);
      announce.setDate(announce.getDate() - 28);
      const days = daysUntil(announce, this.today);

      let countdown;
      if (days < 0) countdown = this.I.new_soon || 'New sessions coming soon';
      else if (days === 0) countdown = this.I.new_today || 'New sessions published today';
      else if (days === 1) countdown = this.I.new_1day || 'New sessions will be published in 1 day';
      else if (days < 14) countdown = tpl(this.I.new_days || 'New sessions will be published in {{ n }} days', { n: days });
      else countdown = tpl(this.I.new_weeks || 'New sessions will be published in {{ n }} weeks', { n: Math.ceil(days / 7) });

      wrap.innerHTML = `
        <div class="workshop-booking__announce-text">
          <strong>${countdown}</strong>
          <a href="#" data-scroll-newsletter>Subscribe to the workshop newsletter to get notified →</a>
        </div>
      `;
      const a = wrap.querySelector('[data-scroll-newsletter]');
      if (a) a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector('[id*="email_workshop_signup_banner"], .email-workshop-signup-banner');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return wrap;
    }

    setFilter(value) {
      this.state.filter = value;
      this.renderCalendar();
      // Sync Format-Kacheln (auch wenn Filter via Segmented gesetzt wurde)
      this.querySelectorAll('[data-format]').forEach(c =>
        c.classList.toggle('is-active', c.dataset.format === value)
      );
      this.dispatchEvent(new CustomEvent('wb:state', {
        bubbles: true,
        detail: { model: this.state.model, filter: this.state.filter },
      }));
    }

    hoverVariant(variantId, on) {
      // Hover funktioniert auch nach Selektion — Selected-Cells haben CSS-Schutz
      // (is-selected überschreibt is-hovered für die selected-Variant).
      this.calendarEl.querySelectorAll(`[data-variant-id="${variantId}"]`).forEach(c =>
        c.classList.toggle('is-hovered', on)
      );
    }

    selectDate(model, variantId) {
      this.state.model = model;
      this.state.variantId = variantId;
      this.state.notSure = false;

      const info = this.variantInfo.get(variantId);
      this.state.maxQty = Math.max(1, Math.min(4, info ? info.qty : 1));
      this.setQty(1);
      this.renderQtyBtns();

      this.renderCalendar();
      this.steps.qty.hidden = false;
      this.steps.voucherModel.hidden = true;
      this.steps.voucher.hidden = true;
      if (this.seatsHeadingEl) this.seatsHeadingEl.textContent = '3. Who is each seat for?';
      if (this.giftExtra) this.giftExtra.hidden = true;
      this.refreshFlow();
    }

    gotoVoucher() {
      this.state.notSure = true;
      this.state.variantId = null;
      this.state.model = null;

      this.querySelectorAll('input[name="voucher_model"]').forEach(r => r.checked = false);

      this.renderCalendar();
      this.steps.voucherModel.hidden = false;
      this.steps.voucher.hidden = true;
      this.steps.qty.hidden = true;
      if (this.seatsHeadingEl) this.seatsHeadingEl.textContent = '2. Who is this voucher for?';
      this.refreshFlow();
    }

    selectVoucherModel(value) {
      this.state.model = value;
      this.steps.voucher.hidden = false;
      this.state.maxQty = 1;
      this.setQty(1);
      this.refreshFlow();
    }

    renderQtyBtns() {
      this.qtyBtnsEl.querySelectorAll('[data-qty]').forEach(btn => {
        const n = parseInt(btn.dataset.qty, 10);
        btn.disabled = n > this.state.maxQty;
        btn.classList.toggle('is-active', n === this.state.qty);
      });
    }

    setQty(n) {
      n = Math.max(1, Math.min(this.state.maxQty || 1, n));
      this.state.qty = n;
      const seats = this.state.seats.slice(0, n);
      while (seats.length < n) seats.push({ type: 'self', name: '', email: '' });
      this.state.seats = seats;
      if (this.qtyMetaEl) {
        const maxNote = this.state.maxQty < 4 ? ` · ${this.state.maxQty} available` : '';
        this.qtyMetaEl.textContent = (n === 1 ? (this.I.one_seat || '1 seat') : tpl(this.I.n_seats || '{{ n }} seats', { n })) + maxNote;
      }
      this.renderQtyBtns();
      this.renderSeats();
      this.refreshFlow();
    }

    renderSeats() {
      if (!this.seatsEl) return;
      this.seatsEl.innerHTML = '';

      if (this.state.notSure) {
        // Voucher: single recipient block, kein "Seat 1"
        const seat = this.state.seats[0] || { type: 'self', name: '' };
        const block = document.createElement('div');
        block.className = 'workshop-booking__seat';
        block.innerHTML = `
          <div class="workshop-booking__seat-head">
            <span class="workshop-booking__seat-toggle">
              <label><input type="radio" name="voucher-rec" value="self" ${seat.type === 'self' ? 'checked' : ''}><span>For me</span></label>
              <label><input type="radio" name="voucher-rec" value="other" ${seat.type === 'other' ? 'checked' : ''}><span>For someone else</span></label>
            </span>
          </div>
          <div data-voucher-self ${seat.type !== 'self' ? 'hidden' : ''}></div>
          <div data-voucher-other ${seat.type !== 'other' ? 'hidden' : ''}>
            <div class="field">
              <input type="text" class="field__input" id="wb-voucher-recipient" data-seat-name="0" value="${seat.name || ''}" placeholder="${this.I.recipient_name || 'Recipient name'}">
              <label class="field__label" for="wb-voucher-recipient">Recipient name</label>
            </div>
          </div>
        `;
        block.querySelectorAll('input[name="voucher-rec"]').forEach(r => {
          r.addEventListener('change', (e) => {
            this.state.seats[0].type = e.target.value;
            this.renderSeats();
            this.refreshFlow();
          });
        });
        if (seat.type === 'other') {
          block.querySelector('[data-seat-name="0"]').addEventListener('input', (e) => {
            this.state.seats[0].name = e.target.value;
            this.refreshBuy();
          });
        }
        this.seatsEl.appendChild(block);

        // Voucher: gift-extra zeigen wenn "other"
        if (this.giftExtra) this.giftExtra.hidden = seat.type !== 'other';
        if (this.infoBox) this.infoBox.hidden = true;  // Voucher-Pfad: keine Session-Info
        return;
      }

      // Workshop-Multi-Seat
      this.state.seats.forEach((seat, idx) => {
        const block = document.createElement('div');
        block.className = 'workshop-booking__seat';

        const head = document.createElement('div');
        head.className = 'workshop-booking__seat-head';
        head.innerHTML = `
          <span class="workshop-booking__seat-num">Seat ${idx + 1}</span>
          <span class="workshop-booking__seat-toggle">
            <label><input type="radio" name="seat-${idx}" value="self" ${seat.type === 'self' ? 'checked' : ''}><span>For me</span></label>
            <label><input type="radio" name="seat-${idx}" value="other" ${seat.type === 'other' ? 'checked' : ''}><span>Someone else</span></label>
          </span>
        `;
        block.appendChild(head);

        if (seat.type === 'other') {
          const fields = document.createElement('div');
          fields.className = 'workshop-booking__seat-fields';
          fields.innerHTML = `
            <div class="field">
              <input type="text" class="field__input" id="wb-seat-name-${idx}" data-seat-name="${idx}" value="${seat.name || ''}" placeholder="Name">
              <label class="field__label" for="wb-seat-name-${idx}">Name</label>
            </div>
          `;
          block.appendChild(fields);
        }

        head.querySelectorAll(`input[name="seat-${idx}"]`).forEach(r => {
          r.addEventListener('change', (e) => {
            this.state.seats[idx].type = e.target.value;
            this.renderSeats();
            this.refreshFlow();
          });
        });
        if (seat.type === 'other') {
          block.querySelector(`[data-seat-name="${idx}"]`).addEventListener('input', (e) => {
            this.state.seats[idx].name = e.target.value;
            this.refreshBuy();
          });
        }
        this.seatsEl.appendChild(block);
      });

      const anyOther = this.state.seats.some(s => s.type === 'other');
      if (this.infoBox) {
        this.infoBox.hidden = false;
        if (this.infoTextEl) {
          this.infoTextEl.textContent = anyOther
            ? "I'll send all session details by email about a week before the first date; please share them with your guest."
            : "I'll send all session details by email about a week before the first date.";
        }
      }
      if (this.giftExtra) this.giftExtra.hidden = true;
    }

    refreshFlow() {
      if (this.state.notSure) {
        this.steps.seats.hidden = !this.state.model;
        if (this.state.model && !this.seatsEl.children.length) this.renderSeats();
      } else if (this.state.variantId) {
        this.steps.seats.hidden = false;
      } else {
        this.steps.seats.hidden = true;
      }
      this.steps.buy.hidden = !this.canBuy();
      this.renderSummary();
      this.refreshBuy();
      this.dispatchEvent(new CustomEvent('wb:state', {
        bubbles: true,
        detail: { model: this.state.model, filter: this.state.filter },
      }));
    }

    canBuy() {
      // Voucher
      if (this.state.notSure && this.state.model) {
        const seat = this.state.seats[0];
        if (!seat || seat.type === 'self') return true;
        return !!seat.name.trim();
      }
      // Workshop: nur Namen für Other-Sitze
      if (!this.state.variantId) return false;
      return this.state.seats.every(s => s.type === 'self' || s.name.trim());
    }

    refreshBuy() {
      let label = this.I.book || 'Book';
      const price = this.state.model === 'workshop' ? 290 : (this.state.model === 'evening' ? 160 : 0);
      const disabled = !this.canBuy();

      if (this.state.notSure && this.state.model) {
        label = `Buy voucher · ${price} EUR`;
      } else if (this.state.variantId) {
        const total = price * this.state.qty;
        const seatTxt = this.state.qty === 1 ? (this.I.one_seat || '1 seat') : tpl(this.I.n_seats || '{{ n }} seats', { n: this.state.qty });
        label = tpl(this.I.book_summary || 'Book {{ seats }} · {{ total }} EUR', { seats: seatTxt, total });
      } else {
        label = this.I.pick_date || 'Pick a date';
      }

      this.buyLabel.textContent = label;
      this.buyBtn.disabled = disabled;
    }

    renderSummary() {
      if (!this.summaryEl) return;
      this.summaryEl.innerHTML = '';

      if (this.state.notSure && this.state.model) {
        const fmtLabel = this.state.voucherFormat === 'digital'
          ? (this.I.digital_pdf || 'Digital PDF — goes to your checkout email')
          : (this.I.printed_card || 'Printed card — by post to your address');
        const modelLabel = this.state.model === 'workshop' ? (this.I.model_workshop || 'Three-Session Workshop') : (this.I.model_evening || 'One-Session Evening');
        const price = this.state.model === 'workshop' ? '290 EUR' : '160 EUR';
        this.summaryEl.innerHTML = `
          <div class="workshop-booking__summary-title">Your voucher</div>
          <div class="workshop-booking__summary-line"><span>${modelLabel}</span><span>${price}</span></div>
          <div class="workshop-booking__summary-line"><span>${fmtLabel}</span><span></span></div>
        `;
        return;
      }

      if (!this.state.variantId) return;
      const info = this.variantInfo.get(this.state.variantId);
      if (!info) return;

      const modelLabel = info.model === 'workshop' ? (this.I.model_workshop || 'Three-Session Workshop') : (this.I.model_evening || 'One-Session Evening');
      const lines = info.sessions.map(s => {
        const d = s.date;
        const wd = WD_LABELS_SHORT_SUN0[d.getDay()];
        const time = s.from && s.to ? `${s.from} – ${s.to}` : (s.from || '');
        const dateStr = `${wd}, ${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
        const labelStr = s.label ? `<span class="workshop-booking__summary-label">${s.label}</span>` : '';
        return `<div class="workshop-booking__summary-line"><span>${dateStr}${labelStr ? ' · ' + labelStr : ''}</span><span>${time}</span></div>`;
      }).join('');

      // Evening: Trimming + Glazing macht das Studio (keine eigene Session)
      const studioLine = info.model === 'evening'
        ? `<div class="workshop-booking__summary-line"><span><span class="workshop-booking__summary-label">Trimming · Glazing</span></span><span>by the studio</span></div>`
        : '';

      // Pick-up: 3 Wochen nach letztem Termin (Brennzyklus)
      const pickup = new Date(info.lastDate);
      pickup.setDate(pickup.getDate() + 21);
      const pickupWd = WD_LABELS_SHORT_SUN0[pickup.getDay()];
      const pickupStr = `${pickupWd}, ${pickup.getDate()} ${MONTHS_SHORT[pickup.getMonth()]}`;
      const pickupLine = `<div class="workshop-booking__summary-line workshop-booking__summary-line--pickup"><span>${pickupStr} · <span class="workshop-booking__summary-label">Pieces pick-up</span></span><span>approx.</span></div>`;

      this.summaryEl.innerHTML = `
        <div class="workshop-booking__summary-title">${modelLabel}</div>
        ${lines}
        ${studioLine}
        ${pickupLine}
      `;
    }

    render() {
      Object.entries(this.steps).forEach(([k, el]) => {
        if (!el) return;
        if (k === 'calendar') return;
        el.hidden = true;
      });
    }

    async submit(e) {
      e.preventDefault();
      if (this.buyBtn.disabled) return;
      this.buyBtn.disabled = true;
      const originalLabel = this.buyLabel.textContent;
      this.buyLabel.textContent = 'Adding…';

      try {
        let payload;
        if (this.state.notSure && this.state.model) {
          const variantId = this.voucherIds[this.state.model][this.state.voucherFormat];
          const properties = {};
          const seat = this.state.seats[0];
          if (seat && seat.type === 'other') {
            properties['Recipient name'] = seat.name.trim();
            const from = this.querySelector('#wb-gift-from');
            const msg = this.querySelector('#wb-gift-msg');
            if (from && from.value.trim()) properties['From'] = from.value.trim();
            if (msg && msg.value.trim()) properties['Message'] = msg.value.trim();
          }
          payload = { items: [{ id: variantId, quantity: 1, properties }] };
        } else {
          const items = this.state.seats.map((seat, idx) => {
            const properties = { 'Seat': `${idx + 1} of ${this.state.qty}` };
            if (seat.type === 'other') {
              properties['Participant name'] = seat.name.trim();
            } else {
              properties['Participant'] = 'self (buyer)';
            }
            return { id: this.state.variantId, quantity: 1, properties };
          });
          payload = { items };
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });
        if (!res.ok) {
          const err = await res.json().catch(() => null);
          throw new Error((err && (err.description || err.message)) || this.I.add_failed || 'Add to cart failed');
        }
        window.location.href = '/cart';
      } catch (err) {
        console.error('[workshop-booking]', err);
        this.buyLabel.textContent = err.message || this.I.add_error || 'Could not add to cart';
        setTimeout(() => { this.buyLabel.textContent = originalLabel; this.refreshBuy(); }, 2500);
      }
    }
  }

  customElements.define('workshop-booking', WorkshopBooking);
})();
